import { gql } from '@apollo/client';

export const GET_HIERARCHY_COMPANY_UNITS_QUERY = gql`
  query SalesWebHierarchyCompanyUnits($id: ID!) {
    company(id: $id) {
      id
      units {
        id
        name
      }
    }
  }
`;
